<template>
  <div class="container md-elevation-2">
    <div class="column left-column">
      <span class="assignment-name">{{ assignment.name }}</span>
      <div class="column case-data">
        <md-progress-bar v-if="loading" md-mode="indeterminate" />
        <div v-if="!loading" class="column">
          <span class="case-name">Scenario Name: {{ caseName }}</span>
          <span class="heading">Learning Objective</span>
          <span class="paragraph">{{ learningObjectives }}</span>
          <span class="heading">Dispatch Information</span>
          <span class="paragraph">{{ dispatchInformation }}</span>
          <span class="heading">Groups</span>
          <span class="paragraph">{{ groupList }}</span>        
          <span class="heading">Students</span>
          <span class="paragraph">{{ studentList }}</span>        
        </div>
      </div>
      <div class="left-bottom">
        <md-button class="blue-4 bg" @click="openAssignmentGrades">View Assignment Results</md-button>
      </div>
    </div>
    <div class="column right-column">
      <div class="column">
        <span class="heading">Status</span>
        <span class="paragraph gray-2 color">{{ status }}</span>
        <span class="heading">Number of Attempts</span>
        <span class="paragraph gray-2 color">{{ assignment.attemptsCount }}</span>
        <table class="paragraph">
          <tr>
            <td class="heading">Start Date</td>
            <td class="heading">Start Time</td>
          </tr>
          <tr>
            <td class="paragraph gray-2 color">{{ assignment.startTime | formatDate }}</td>
            <td class="paragraph gray-2 color">{{ assignment.startTime | formatTime }}</td>
          </tr>
        </table>
        <table class="paragraph">
          <tr>
            <td class="heading">End Date</td>
            <td class="heading">End Time</td>
          </tr>
          <tr>
            <td class="paragraph gray-2 color">{{ assignment.endTime | formatDate }}</td>
            <td class="paragraph gray-2 color">{{ assignment.endTime | formatTime }}</td>
          </tr>
        </table>
      </div>
      <div class="right-bottom">
        <md-button v-if="canEdit" class="blue-4 bg" @click="editAssignment">Edit Assignment</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { userLabel, groupLabel } from '~lib/common/utils/labels';

export default {
  name: 'assignment-details',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    assignment: {
      type: Object,
      required: true,
    },
    caseConf: {
      type: Object,
      default: undefined,
    },
    orgData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    caseName() {
      return get(this.assignment, 'caseName') || get(this.caseConf, 'name', 'Unavailable');
    },
    learningObjectives() {
      return get(this.caseConf, 'dispatch.learningObjectives.caption.en') || '';
    },
    dispatchInformation() {
      return get(this.caseConf, 'dispatch.chiefComplaint.caption.en') || '';
    },
    groupList() {
      let result = '';
      const groupIds = get(this.assignment, 'students.groups') || [];
      groupIds.forEach((groupId, index) => {
        if (index > 0) {
          result += ', ';
        }
        const group = this.orgData && this.orgData.groups.find(grp => grp._id === groupId);
        if (group) {
          result += groupLabel(group);
        }
      });
      return result;
    },
    studentList() {
      let result = '';
      const userIds = get(this.assignment, 'students.users') || [];
      userIds.forEach((userId, index) => {
        if (index > 0) {
          result += ', ';
        }
        const user = this.orgData && this.orgData.users.find(u => u.user_id === userId);
        if (user) {
          result += userLabel(user);
        }
      });
      return result;
    },
    status() {
      const now = new Date().toJSON();
      if (this.assignment.startTime > now) {
        return 'Pending';
      } else if (this.assignment.startTime <= now && this.assignment.endTime >= now) {
        return 'In Progress';
      } else if (this.assignment.endTime < now) {
        return 'Complete';
      }
      return '--';
    },
    canEdit() {
      return this.assignment.status !== 'COMPLETE' && this.status !== 'Complete';
    },
  },
  mounted() {
    this.$analytics.event('Assignments', 'assignments_detail_view');
  },
  methods: {
    openAssignmentGrades() {
      this.$emit('openAssignmentGrades');
      this.$analytics.event('Assignments', 'assignments_view_results');
    },
    editAssignment() {
      this.$emit('editAssignment');
    },
  }
};
</script>

<style scoped>
.container {
  background-color: white;
  height: 100%;
  padding: 25px 0px;
  display: flex;
}

.column {
  display: flex;
  flex-direction: column;
}

.left-column {
  border-right: 2px solid blue;
  padding: 0px 20px;
  flex: 3;
  justify-content: space-between;
}

.right-column {
  padding: 0px 20px;
  flex: 2;
  justify-content: space-between;
}

.case-data {
  flex: 1;
  overflow: auto;
  margin-bottom: 10px;
}

.assignment-name {
  font-size: 2.5em;
  margin-bottom: 0.6em;
  line-height: 1.2em;
}

.case-name {
  font-size: 1.2em;
  font-weight: 500;
  margin-bottom: 1em;
}

.heading {
  font-size: 1.3em;
  margin-bottom: .4em;
}

.paragraph {
  font-size: 1em;
  margin-bottom: 1.2em;
}

.left-bottom {
  text-align: start;
}

.right-bottom {
  text-align: end;
}

.md-button {
  margin: 0;
  padding: 0;  
}

</style>